import { render } from "./funcItemB.vue?vue&type=template&id=70095f9a&ts=true"
import script from "./funcItemB.vue?vue&type=script&lang=ts"
export * from "./funcItemB.vue?vue&type=script&lang=ts"

import "./funcItemB.vue?vue&type=style&index=0&id=70095f9a&lang=scss&scope=this%20api%20replaced%20by%20slot-scope%20in%202.5.0%2B"

import exportComponent from "E:\\xiangqukejidaima\\米优时官网\\miyoushi-web (3)\\miyoushi-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__